var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'jsx-dom';
import { attr, memoize, listen } from '@exadel/esl/modules/esl-utils/decorators';
import { UIPSetting } from '../base-setting/base-setting';
export class UIPSliderSetting extends UIPSetting {
    connectedCallback() {
        super.connectedCallback();
        const $inner = React.createElement(React.Fragment, null,
            React.createElement("label", null,
                React.createElement("span", null, this.label),
                this.$field),
            this.$fieldValue);
        this.append($inner);
    }
    disconnectedCallback() {
        this.innerHTML = '';
        super.disconnectedCallback();
    }
    /** Range input to change setting's value */
    get $field() {
        return React.createElement("input", { type: "range", min: this.min, max: this.max, step: this.step });
    }
    /** Container for current value */
    get $fieldValue() {
        return React.createElement("div", { className: "slider-value" });
    }
    /** Handles `input` event to display its current value */
    updateSliderValue() {
        this.$fieldValue.textContent = `Value: ${this.$field.value}`;
    }
    updateFrom(model) {
        super.updateFrom(model);
        const values = model.getAttribute(this.target, this.attribute);
        if (!values.length) {
            this.setInconsistency(this.NO_TARGET_MSG);
        }
        else if (!values[0]) {
            this.setInconsistency(this.NOT_VALUE_SPECIFIED_MSG);
        }
        else {
            this.setValue(values[0]);
        }
    }
    getDisplayedValue() {
        return this.$field.value;
    }
    setValue(value) {
        if (value) {
            this.$field.value = value;
            this.updateSliderValue();
        }
    }
    setInconsistency(msg = this.INCONSISTENT_VALUE_MSG) {
        this.$fieldValue.textContent = msg;
    }
    setDisabled(force) {
        this.$fieldValue.classList.toggle('disabled', force);
        this.$field.toggleAttribute('disabled', force);
    }
}
UIPSliderSetting.is = 'uip-slider-setting';
__decorate([
    attr({ defaultValue: '' })
], UIPSliderSetting.prototype, "label", void 0);
__decorate([
    attr({ defaultValue: '0' })
], UIPSliderSetting.prototype, "min", void 0);
__decorate([
    attr({ defaultValue: '0' })
], UIPSliderSetting.prototype, "max", void 0);
__decorate([
    attr({ defaultValue: '0' })
], UIPSliderSetting.prototype, "step", void 0);
__decorate([
    memoize()
], UIPSliderSetting.prototype, "$field", null);
__decorate([
    memoize()
], UIPSliderSetting.prototype, "$fieldValue", null);
__decorate([
    listen('input')
], UIPSliderSetting.prototype, "updateSliderValue", null);
